import React from 'react';
import { default as withRouter } from "../../components/WithRouter/withRouter";

import Registration, { RegistrationTypes } from '../Registration/Registration';
import CalculatorLayout from '../../components/CalculatorLayout/CalculatorLayout';

class ImIndigenous extends React.Component {
  onSuccess = async form => {
    this.props.history.push('/thankyou');
  }

  subtext() {
    return (
      <>
        <p>
          Interested in exploring what a Regional Reciprocity Trust could support in your territory?
        </p>
        <p>
          <a href="#indigenous-form" className="btn btn-link p-0 font-weight-bold" style={{ fontSize: '1.2rem' }}>
            Start here <i className="fa fa-arrow-down"></i>
          </a>
        </p>
        <p>
          Regional Reciprocity Trusts are established at the pace of trusting relationships, shaped by local Indigenous principles and priorities and governed entirely by the Nations who join them.
        </p>
        <p>
          When a Nation appoints a Trustee to a Regional Trust, the decisions about how funds flow and what priorities they support stay where they belong: with the community. The Trust provides a reliable, ongoing, and independent revenue stream that grows as land values increase — without federal or provincial strings attached.
        </p>
      </>
    )
  }

  render() {
    return (
      <CalculatorLayout title="'m indigenous" highlightChar="i">
        <h2 className={`marginBottom25 text-center`}>
          <span className="reciprocityGreenText">r</span>eciprocity for Indigenous Nations<span className="reciprocityLightBlueText">.</span>
        </h2>
        <div id="indigenous-form">
          <Registration type={RegistrationTypes.indigenous} image={'/assets/reciprocity-indigenous-logo.png'} submitText="Submit"
            buttonColor="#7FC329"
            subText={this.subtext()}
            onSuccess={this.onSuccess}
          />
        </div>
      </CalculatorLayout>
    )
  }
}

export default withRouter(ImIndigenous);
